import { cn, RadioButton, type RadioItem, useMediaQuery } from "@kyan/ui";
import { usePathname } from "next/navigation";

import { PerpsOrderbook } from "#/app/(desktop)/perps/components/PerpsOrderbook/PerpsOrderbook";
import { routes } from "#/config/routes";
import { usePerpTradeType } from "#/store/perps/tradePanel/perpTradeType";
import type { TradeType } from "#/types/trade";

import { TradeButton } from "../TradeButton/TradeButton";
import { PerpSummary } from "./components/PerpSummary/PerpSummary";
import { PerpTradeDetails } from "./components/PerpTradeDetails/PerpTradeDetails";
import { PortfolioImpact } from "./components/PortfolioImpact/PortfolioImpact";

const items: RadioItem<TradeType>[] = [
  { id: "market", label: "Market", className: "flex-1" },
  { id: "limit", label: "Limit", className: "flex-1" },
  // { id: "rfq", label: "RFQ", className: "flex-1" },
];

export const PerpsTab: React.FC = () => {
  const { isSm } = useMediaQuery();
  const { perpTradeType, setPerpTradeType } = usePerpTradeType();
  const pathname = usePathname();
  const isPerpPage = pathname === routes.perps;

  const handleChangeTradeType = (id: TradeType) => {
    setPerpTradeType(id);
  };

  return (
    <div className="flex h-full max-h-[65vh] flex-col overflow-y-auto sm:max-h-none">
      <RadioButton
        items={items}
        variant="secondary"
        value={perpTradeType}
        size={isSm ? "md" : "xl"}
        className="mt-4.5 w-full gap-3 sm:px-4"
        onChange={handleChangeTradeType}
      />
      <div className="flex h-full flex-col pt-1 pb-3 sm:px-4">
        <PerpSummary />
        <PerpTradeDetails />
        <PortfolioImpact />
        <TradeButton />
        <div
          className={cn("mt-7 mb-1", {
            "border-divider rounded-md border": !isPerpPage,
          })}
        >
          {!isPerpPage && (
            <PerpsOrderbook fullWidth layerSize={1} isPerpPage={false} />
          )}
        </div>
      </div>
    </div>
  );
};
